<template>
  <div
    class="menu-item"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="handleUrl()"
    :class="{ hovered: hover }">
    <img v-if="icon" :src="icon" class="menu-icon" />
    <div class="menu-name">{{ name }}</div>
    <img v-if="index != length - 1" class="jiantou" />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
    index: {
      type: Number,
      required: false,
    },
    length: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    handleUrl() {
      if (this.item && this.item.isToUrl) {
        this.$router.push(this.item.toUrl);
      }
    },
  },
};
</script>

<style scoped>
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  transition: background-color 0.3s;
  margin-right: 60px;
  position: relative;
  cursor: pointer;
}

.menu-item.hovered {
  background-color: #f0f0f0;
}

.menu-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 5px;
}

.menu-name {
  font-size: 14px;
  color: #333;
}
.jiantou {
  position: absolute;
  width: 30px;
  right: -130px;
  top: 20%;
  transform: translateX(-50%);
}
</style>
